// extracted by css-extract-rspack-plugin
var _1 = "container__NTvWR";
var _2 = "description__srR9D";
var _3 = "licensingGeneralInfo__AlrGL";
export { _1 as "container", _2 as "description", _3 as "licensingGeneralInfo" }
export default { "container": _1, "description": _2, "licensingGeneralInfo": _3 }
